import { formatDate } from '@juvare/common-web-ui/utils';
export function getAccountBadgeStatusDateText(t, status, expiresAt, statusLastUpdatedAt) {
    if (status === 'valid') {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.expiresOn', {
            date: formatDate(new Date(expiresAt), 'UTC'), // display utc date
        });
    }
    if (status === 'expired') {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.expiredOn', {
            date: formatDate(new Date(expiresAt), 'UTC'), // display utc date
        });
    }
    if (status === 'revoked' && statusLastUpdatedAt) {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.revokedOn', {
            date: new Date(statusLastUpdatedAt).toLocaleDateString(),
        });
    }
    return '';
}
